import * as React from 'react'
import { SVGProps } from 'react'
const SvgAddressHome = (props: SVGProps<SVGSVGElement>) => (
  <svg width={200} height={192} viewBox="0 0 150 144" {...props}>
    <path d="M48.8 25.1C34.9 38.4 18.3 54.4 11.9 60.6L.4 71.8l1.7 2.4 1.8 2.3L8.4 72l4.6-4.4V143h120V67h-6v70H20l-.2-34.7-.3-34.8-2.6-.5c-2.4-.5-.2-2.9 27.1-28.9C60.4 22.5 74.1 9.8 74.5 9.8c.3 0 14.2 13 30.8 28.9 42.9 41 40.4 38.8 42.2 37.3.8-.7 1.5-1.8 1.5-2.5 0-1-43.5-43.3-69.2-67.4L74.1.8 48.8 25.1z" />
  </svg>
)
export default SvgAddressHome
